module.exports = __webpack_public_path__ + "static/img/6661_phase_function_Paper_Points.7d86f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6661_phase_function_Paper_Points.png
// module id = 1ht2
// module chunks = 0